module.exports = __webpack_public_path__ + "static/media/Group4.bf69edb9.png";